export function initPreviewVideo() {
    for( const videoWrapper of document.querySelectorAll('.previewVideo') ) {
        const videos = videoWrapper.querySelectorAll('video');
        if(!videos){
            return;
        }
        const shortVideo = videoWrapper.querySelector(".previewVideo__preview video");
        const mainVideo = videoWrapper.querySelector(".previewVideo__main video");
        const playButton = videoWrapper.querySelector(".playbtn");

        if(playButton && mainVideo){
            const muteButton = videoWrapper.querySelector(".mutebtn");

            const toggleVideo = () => {
                if(videoWrapper.classList.contains("is-active")){
                    videoWrapper.classList.remove('is-active');
                    if(shortVideo) {
                        shortVideo.play();
                        shortVideo.closest('.previewVideo__preview').style.display = '';
                        mainVideo.closest('.previewVideo__main').style.display = 'none';
                    }
                    mainVideo.pause();
                }else{
                    videoWrapper.classList.add('is-active');
                    if(shortVideo) {
                        shortVideo.pause();
                        shortVideo.closest('.previewVideo__preview').style.display = 'none';
                    }
                    mainVideo.play();
                    mainVideo.closest('.previewVideo__main').style.display = '';
                }
                // Zustand ansagen, nicht nur ueber die Icon-Klasse zeigen
                // (dcLens 27.08.2026, a11y/button-name).
                playButton.setAttribute('aria-pressed', String(videoWrapper.classList.contains('is-active')));
            };

            playButton.addEventListener('click', toggleVideo);

            mainVideo.addEventListener('ended', () => {
                if(videoWrapper.classList.contains("is-active")){
                    toggleVideo();
                }
            });

            muteButton.addEventListener('click', function (){
                if(videoWrapper.classList.contains("is-muted")){
                    videoWrapper.classList.remove('is-muted');
                    shortVideo.muted = false;
                    mainVideo.muted = false;
                }else{
                    videoWrapper.classList.add('is-muted');
                    shortVideo.muted = true;
                    mainVideo.muted = true;
                }
                muteButton.setAttribute('aria-pressed', String(videoWrapper.classList.contains('is-muted')));
            });
        }
    }
}